import { useMemo } from 'react'
import classnames from 'classnames'
import { Button } from '../button'
import { format, parseISO } from '../../utils/date-service'

const amountOptions = {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
}

export default function Offers({ offers, forBuyer, onClick, isDisabled }) {
  const offerToAccept = useMemo(
    () =>
      forBuyer
        ? offers
            ?.slice(0)
            ?.sort(
              (a, b) =>
                parseISO(b.offeredAt, { withTime: true }) -
                parseISO(a.offeredAt, { withTime: true }),
            )
            ?.find((offer) => offer.sellerId)
        : offers
            ?.slice(0)
            ?.sort(
              (a, b) =>
                parseISO(b.offeredAt, { withTime: true }) -
                parseISO(a.offeredAt, { withTime: true }),
            )
            ?.find((offer) => offer.buyerId),
    [forBuyer, offers],
  )

  return (
    <div className='offersWrapper'>
      {offers.map((offer) => (
        <div
          key={offer.offeredAt}
          className={classnames('offerContainer flex', {
            receiver: (offer.sellerId == null && !forBuyer) || (offer.sellerId && !!forBuyer),
          })}
        >
          <div className='offer'>
            <div className='date'>
              {format(parseISO(offer.offeredAt, { withTime: true }), 'MMM dd, hh:mm aa')}
            </div>
            <div className='amount'>
              {Number(offer.offeredAmount).toLocaleString('en-US', amountOptions)}
            </div>
          </div>
          {offer === offerToAccept && (
            <Button disabled={isDisabled} onClick={onClick}>
              Accept
            </Button>
          )}
        </div>
      ))}

      <style jsx>{`
        .offersWrapper {
          position: relative;
          overflow: auto;
          height: calc(
            100% -
              (
                var(--offersHeaderHeight) + var(--offersFooterHeight) + 2 *
                  var(--offersVerticalPadding)
              ) - 2rem
          );
          margin: 0 0 2rem;
          padding: 0 0 0 1.7rem;
        }

        .offerContainer {
          justify-content: flex-end;
          width: 100%;
          margin: 2.4rem 0 0;

          .offer {
            text-align: right;
          }

          &.receiver {
            justify-content: flex-start;

            .offer {
              text-align: left;
            }

            .date {
              padding: 0 0 0 1.6rem;
            }

            .amount {
              background: #1a1e21;
            }
          }

          .date {
            margin: 0 0 0.8rem;
            padding: 0 1.6rem 0 0;
            color: var(--secondary-text-color);
            font-size: 1.4rem;
            font-weight: 700;
          }

          .amount {
            display: inline-block;
            padding: 1.1rem 1.6rem;
            border-radius: 0.9rem;
            background: #d7e8fd;
            font-size: 1.8rem;
          }

          :global(button) {
            align-self: flex-end;
            width: 11.4rem;
            min-width: unset;
            padding: unset;
          }
        }

        @media (max-width: 1024px) {
          .offersWrapper {
            height: calc(
              100% -
                (
                  var(--offersHeaderHeight) + var(--offersFooterHeight) + 2 *
                    var(--offersVerticalPadding)
                ) - 2rem
            );
          }

          .offerContainer {
            margin: 1rem 0 0;

            .date {
              margin: 0 0 0.5rem;
              font-size: 1.2rem;
            }

            .amount {
              font-size: 1.4rem;
            }

            :global(button) {
              width: 7.6rem;
              min-width: unset;
              padding: unset;
              font-size: 1.2rem;
            }
          }
        }
      `}</style>
    </div>
  )
}
